import Vue from 'vue';
import VueRouter from 'vue-router';
// import CheckOut from '@/components/CheckOut.vue'; // 引入支付组件
// import ApplePayTest from '@/components/ApplePayTest.vue'; // 引入支付组件
import ApplePay from '@/components/ApplePay.vue'; // 引入支付组件
import GooglePay from '@/components/GooglePay.vue'; // 引入支付组件
import NewGooglePay from '@/components/NewGooglePay.vue'; // 引入支付组件
import DigitalCash from '@/components/DigitalCash.vue'; // 引入支付组件
import CodaPay from '@/components/CodaPay.vue'; // 引入支付组件
import AdyenPay from '@/components/AdyenPay.vue'; // 引入支付组件
Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/checkout/:encryptedString',
    //     name: 'CheckOut',
    //     component: CheckOut,  // 绑定 CheckOut 组件
    // },
    // {
    //     path: '/applepaytest/:encryptedString',
    //     name: 'ApplePayTest',
    //     component: ApplePayTest,  // 绑定 CheckOut 组件
    // },
    {
        path: '/applepay/:encryptedString',
        name: 'ApplePay',
        component: ApplePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/googlepay/:encryptedString',
        name: 'GooglePay',
        component: GooglePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/newgooglepay/:encryptedString',
        name: 'NewGooglePay',
        component: NewGooglePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/digitalcash/:encryptedString',
        name: 'DigitalCash',
        component: DigitalCash,  // 绑定 CheckOut 组件
    },
    {
        path: '/coda/:encryptedString',
        name: 'CodaPay',
        component: CodaPay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adpay/:encryptedString',
        name: 'AdyenPay',
        component: AdyenPay,  // 绑定 CheckOut 组件
    },
    // 其他路由...
];

const router = new VueRouter({
    mode: 'history',
    routes
});

// 全局路由守卫设置默认标题
router.beforeEach((to, from, next) => {
    // 如果有指定 title 就使用，没有就设置默认值
    document.title = to.meta.title || 'title';
    next();
});

export default router;
